import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class IntentoCompraService {

  url = environment.apiURL + 'intento_compra';
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  constructor(private http: HttpClient) { }
  consulta(data){
    const url = environment.apiURL + 'consulta';
    return this.http.post<any>(url, JSON.stringify(data), this.httpOptions).toPromise();
  }

  sendEmail(idGrupo, idCurso, descuento, name, lastName, email, phone, country, ci?): Promise<any> {
    const urlInsert = this.url;
    return this.http.post<any>(urlInsert, {
      idGrupo: idGrupo,
      idCurso: idCurso,
      descuento: descuento,
      name: name,
      lastName: lastName,
      email: email,
      phone: phone,
      country: country,
      ci: ci
    }).toPromise();
  }
}
